import React from 'react';
import { Translate } from 'react-localize-redux';
import styled from 'styled-components';

import VIDEO_THUMBNAIL from './images/trailer-thumbnail.jpg';
import Section from './section';
import VIDEO_MP4 from './videos/trailer.mp4';
import VIDEO_WEBM from './videos/trailer.webm';

const Id = styled.div`
  border-bottom: 0.3em solid ${props => props.theme.primary};
  color: ${props => props.theme.primary};
  font-family: DINCondensed-Regular;
  font-size: 0.9em;
  margin-left: 0.5em;
  width: 50%;
  position: relative;

  &::before {
    background: ${props => props.theme.primary};
    bottom: -0.3em;
    content: '';
    display: block;
    left: calc(-0.75em / 0.9 - 0.5em);
    position: absolute;
    top: 0.1em;
    transform: skewX(-45deg);
    transform-origin: left bottom;
    width: 0.5em;
  }

  > span {
    margin-left: 1em;
  }
`;

const Wrapper = styled.div`
  border: 2px solid ${props => props.theme.primary};
  margin: 0.375em -0.75em 0;
  padding: 0.75em;
  position: relative;
`;

const Corner = styled.div`
  height: calc(0.75em + 2px);
  position: absolute;
  width: calc(0.75em + 2px);
  border: 0px solid ${props => props.theme.primary};
`;

const CornerTopLeft = styled(Corner)`
  top: -2px;
  left: -2px;
  border-top-width: 4px;
  border-left-width: 4px;
`;

const CornerTopRight = styled(Corner)`
  top: -2px;
  right: -2px;
  border-top-width: 4px;
  border-right-width: 4px;
`;

const CornerBottomLeft = styled(Corner)`
  bottom: -2px;
  left: -2px;
  border-bottom-width: 4px;
  border-left-width: 4px;
`;

const CornerBottomRight = styled(Corner)`
  bottom: -2px;
  right: -2px;
  border-bottom-width: 4px;
  border-right-width: 4px;
`;

const Video = styled.video`
  width: 100%;
`;

const Trailer = ({ gameId }) => {
  let played = false;
  const handlePlay = () => {
    if (!played) {
      played = true;
      window.dataLayer.push({
        event: 'TRAILER_PLAYED',
        gameId
      });
    }
  };

  return (
    <Section
      heading="HOW TO PLAY"
      headingPosition="right"
      slideIn="right"
      subHeading={<Translate id="psyLandingPage.trailer.subtitle" />}
    >
      <Id>
        <span>
          <Translate id="psyLandingPage.trailer.id" />
        </span>
      </Id>
      <Wrapper>
        <CornerTopLeft />
        <CornerTopRight />
        <CornerBottomLeft />
        <CornerBottomRight />
        <Video
          controls
          muted
          onPlay={handlePlay}
          playsInline
          poster={VIDEO_THUMBNAIL}
        >
          <source src={VIDEO_WEBM} type="video/webm" />
          <source src={VIDEO_MP4} type="video/mp4" />
        </Video>
      </Wrapper>
    </Section>
  );
};

export default Trailer;
